// Demo-mode mock data for SmartRx Entry. When DEMO_MODE is true the api.ts
// wrapper short-circuits every request and returns from these arrays so the
// site is fully clickable without the backend.

export const DEMO_MODE = false;

function isoMinutesAgo(min: number): string {
  return new Date(Date.now() - min * 60_000).toISOString();
}
function isoDaysAgo(days: number): string {
  return new Date(Date.now() - days * 86_400_000).toISOString();
}

export const demoQueue = [
  {
    rxId: 1042,
    patientName: "Laura Richmond",
    drug: "Triple Anesthetic Cream",
    rxConfidence: 0.92,
    isControlled: false,
    isCompound: true,
    species: "human",
    warningCount: 0,
    receivedAt: isoMinutesAgo(6),
  },
  {
    rxId: 1043,
    patientName: "Marcus Reed",
    drug: "Testosterone Cypionate 200 mg/mL",
    rxConfidence: 0.88,
    isControlled: true,
    isCompound: false,
    species: "human",
    warningCount: 0,
    receivedAt: isoMinutesAgo(18),
  },
  {
    rxId: 1044,
    patientName: "Bella (canine) — owner: Hannah Pritchard",
    drug: "Trazodone 100 mg Tablet",
    rxConfidence: 0.78,
    isControlled: false,
    isCompound: false,
    species: "canine",
    warningCount: 1,
    receivedAt: isoMinutesAgo(34),
  },
  {
    rxId: 1045,
    patientName: "Doreen Klein",
    drug: "Progesterone 200 mg / Estradiol 1 mg Capsule",
    rxConfidence: 0.95,
    isControlled: false,
    isCompound: true,
    species: "human",
    warningCount: 0,
    receivedAt: isoMinutesAgo(52),
  },
  {
    rxId: 1046,
    patientName: "James O'Connell",
    drug: "Ketamine 50 mg Troche",
    rxConfidence: 0.71,
    isControlled: true,
    isCompound: true,
    species: "human",
    warningCount: 2,
    receivedAt: isoMinutesAgo(78),
  },
  {
    rxId: 1047,
    patientName: "Priya Shah",
    drug: "Tretinoin 0.05% / Niacinamide 4% Cream",
    rxConfidence: 0.93,
    isControlled: false,
    isCompound: true,
    species: "human",
    warningCount: 0,
    receivedAt: isoMinutesAgo(94),
  },
  {
    rxId: 1048,
    patientName: "Walter Hsu",
    drug: "Sildenafil 25 mg Troche",
    rxConfidence: 0.9,
    isControlled: false,
    isCompound: true,
    species: "human",
    warningCount: 0,
    receivedAt: isoMinutesAgo(115),
  },
];

export const demoHolds = [
  {
    rxId: 1031,
    patientName: "Carla Mendez",
    drug: "Naltrexone 4.5 mg LDN Capsule",
    reason: "Waiting on prescriber callback",
    note: "Need DEA verification for compounded ingredients",
    onHoldAt: isoDaysAgo(2),
    placedBy: "Ashley Brown",
  },
  {
    rxId: 1028,
    patientName: "Ethan Walters",
    drug: "Testosterone Cream 50 mg/mL",
    reason: "Missing insurance",
    note: "Patient says BCBS but no member ID provided",
    onHoldAt: isoDaysAgo(1),
    placedBy: "Ryan",
  },
  {
    rxId: 1019,
    patientName: "Sofia Aldana",
    drug: "Sermorelin 1.5 mg/mL Injection",
    reason: "Refill too soon",
    note: "Last fill was 8 days ago, 30-day supply",
    onHoldAt: isoDaysAgo(3),
    placedBy: "Ashley Brown",
  },
];

export const demoImported = [
  {
    rxId: 998,
    patientName: "Greg Ralston",
    drug: "Compounded Pain Cream",
    filedAt: isoDaysAgo(0.1),
    pkRxNumber: "RX-7728401",
    method: "PAD bot",
    reviewedBy: "Ashley Brown",
  },
  {
    rxId: 991,
    patientName: "Janet Liu",
    drug: "Estradiol 0.05 mg/g Cream",
    filedAt: isoDaysAgo(0.3),
    pkRxNumber: "RX-7728397",
    method: "PAD bot",
    reviewedBy: "Ryan",
  },
  {
    rxId: 987,
    patientName: "Buddy (canine) — owner: T. Marsh",
    drug: "Methimazole 5 mg Chew Treat",
    filedAt: isoDaysAgo(0.7),
    pkRxNumber: "RX-7728352",
    method: "PAD bot",
    reviewedBy: "Ashley Brown",
  },
  {
    rxId: 982,
    patientName: "Renee Caldwell",
    drug: "DHEA 25 mg / Pregnenolone 50 mg Capsule",
    filedAt: isoDaysAgo(1.0),
    pkRxNumber: "RX-7728341",
    method: "Manual",
    reviewedBy: "Ashley Brown",
  },
  {
    rxId: 974,
    patientName: "Marcus Reed",
    drug: "Testosterone Cypionate 200 mg/mL",
    filedAt: isoDaysAgo(1.5),
    pkRxNumber: "RX-7728318",
    method: "PAD bot",
    reviewedBy: "Ryan",
  },
  {
    rxId: 968,
    patientName: "Anita Velasquez",
    drug: "Tretinoin 0.025% Cream",
    filedAt: isoDaysAgo(2.2),
    pkRxNumber: "RX-7728294",
    method: "PAD bot",
    reviewedBy: "Ashley Brown",
  },
];

export const demoReportsSummary = {
  windowDays: 30,
  status7d: { pending: 7, on_hold: 3, filed: 42, error: 1 },
  status30d: { pending: 7, on_hold: 3, filed: 168, error: 4 },
  throughput14d: [
    { day: 13, filed: 8 },
    { day: 12, filed: 12 },
    { day: 11, filed: 11 },
    { day: 10, filed: 14 },
    { day: 9,  filed: 9 },
    { day: 8,  filed: 0 },
    { day: 7,  filed: 0 },
    { day: 6,  filed: 13 },
    { day: 5,  filed: 17 },
    { day: 4,  filed: 15 },
    { day: 3,  filed: 11 },
    { day: 2,  filed: 18 },
    { day: 1,  filed: 14 },
    { day: 0,  filed: 6 },
  ],
  accuracyPct: 89,
  avgReviewSeconds: 42,
};

// Single Rx detail used by the Review page when navigated to after upload.
// Shape matches shared/types.ts RxDetail.
export function demoRxDetail(rxId: number) {
  return {
    rxId,
    intakeId: 555,
    extractionId: 777,
    indexInDoc: 0,
    totalRxInDoc: 1,
    siblingRxIds: [],
    status: "matched",
    statusUpdatedAt: isoMinutesAgo(2),
    holdReason: null,
    holdNote: null,
    intake: {
      source: "upload",
      blobPath: "HST/demo/laura-richmond.png",
      originalFilename: (typeof window !== "undefined" && window.sessionStorage.getItem("demo.lastUpload.name")) || "Ideal Image Sample 7.png",
      documentType: "new_rx",
      receivedAt: isoMinutesAgo(2),
      pageCount: 1,
      documentUrl: (typeof window !== "undefined" && window.sessionStorage.getItem("demo.lastUpload.url")) || "/demo-rx.png",
    },
    store: { code: "HST", name: "Houston" },
    patient: {
      nameRaw: "Laura Richmond",
      dobRaw: "1982-12-21",
      phoneRaw: "(501) 428-0553",
      addressRaw: "2510 Ozark Dr, N. Little Rock, AR 72116",
      species: "human",
      petName: null,
      matchConfidence: 0.95,
      matched: {
        pkId: 4407, storeId: 1,
        lastName: "Richmond", firstName: "Laura",
        dob: "1982-12-21", phone: "(501) 428-0553",
      },
    },
    prescriber: {
      nameRaw: "Rex Luttrell, MD",
      npiRaw: "1730312855",
      deaRaw: "BL1234567",
      phoneRaw: "501-235-8813",
      faxRaw: "501-859-0876",
      clinicRaw: "Ideal Image",
      matchConfidence: 0.97,
      matched: {
        pkId: 612, storeId: 1,
        lastName: "Luttrell", firstName: "Rex",
        npi: "1730312855", dea: "BL1234567",
        cannotWriteControlled: false,
      },
    },
    prescription: {
      drug: "Triple Anesthetic Cream",
      genericName: null,
      strength: "benzocaine 10% / lidocaine 3% / tetracaine 2% / phenylephrine 0.01%",
      form: "Cream",
      sig: "Apply to site of laser treatment 60 to 90 minutes prior to procedure",
      quantity: "30 g",
      qtyOnRefills: null,
      daysSupply: 30,
      refills: 3,
      refillIntervalDays: null,
      dawCode: 0,
      rxOrigin: 1,
      dateWritten: "2025-04-11",
      rxExpiration: null,
      counsellingReceived: false,
      rxNote: null,
      dispensingNote: null,
      billingNdc: null,
      shippingMethod: null,
    },
    controlled: { isControlled: false, schedule: null, originalRequiredNote: null },
    compound: {
      isCompound: true,
      base: null,
      notes: null,
      ingredients: [
        { name: "Benzocaine", strengthOrPercent: "10%", quantity: null, isControlled: false, position: 0 },
        { name: "Lidocaine", strengthOrPercent: "3%", quantity: null, isControlled: false, position: 1 },
        { name: "Tetracaine", strengthOrPercent: "2%", quantity: null, isControlled: false, position: 2 },
        { name: "Phenylephrine", strengthOrPercent: "0.01%", quantity: null, isControlled: false, position: 3 },
      ],
    },
    refillAuth: null,
    formula: {
      matchConfidence: 0.96,
      speedCode: "TRIPNUM30",
      matched: {
        formulaId: 14821, storeId: 1,
        name: "PI Triple Numbing Cream",
        form: "Cream", strength: "10/3/2/0.01%",
        drugType: "C", schedule: null,
      },
    },
    rxConfidence: 0.92,
    warnings: [],
  };
}
